import gql from 'graphql-tag';














export const createCommentQuery = gql`
  mutation CreateComment($input: NewCommentInput!) {
    createComment(input: $input) {
      commentId
      resourceId
      parentId
      content
      metadata
      isResolved
      updatedAt
      createdByUser {
        userId
        firstName
        lastName
        imageUrl
      }
      assetIds
      shotId
      sceneId
    }
  }
`;

const createComment = () => ({
  mutation: createCommentQuery,
  module: 'comments',
  buildVariables: ({
    parentId,
    content,
    metadata,
    resourceId,
    assetIds,
    relatedToId,
    relatedToType,
    shotId,
    sceneId,
    disableNotifications
  }) => ({
    input: {
      parentId,
      content,
      metadata,
      resourceId,
      assetIds,
      relatedToId,
      relatedToType,
      shotId,
      sceneId,
      disableNotifications
    }
  })
});

export default createComment;